import { render, staticRenderFns } from "./Votations.vue?vue&type=template&id=b0a8ad5c&"
import script from "./Votations.vue?vue&type=script&lang=js&"
export * from "./Votations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports